import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";


import LoginReg from "./LoginReg";
import axios from "axios";
import ToastMessage from "./ToastMessage";
import toast from "react-hot-toast";
import "../index.css"
import { useTheme } from "../context/ThemeContext";
import { IoIosArrowDown } from "react-icons/io";
import { PiMagnifyingGlassPlusBold } from "react-icons/pi";
import { FaHome } from "react-icons/fa";
import { DownOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';
import { Button, Checkbox } from 'antd';
import { LuMenu } from "react-icons/lu";
import { AuthContext, base_url } from "../context/Authcontext";



export const Header = ({ isSidebar, setSidebar, refreshHeader, show, handleClose, handleShow }) => {
  const { themeColors } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const activeOneClickBtn = useRef(null);
  const [active, setactive] = useState(false);
  const [regactive, setregactive] = useState(false);
 const {
  logout,
  login,
  isAuthenticated,
  userBalnc,
  userInfo,
  userdata,
  
  
} = useContext(AuthContext);

  const [sidebaar, setsidebaar] = useState(false);
  const [activeLink, setActiveLink] = useState("reports");
  const [isOneClickBet, setIsOneClickBet] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [liability, setLiability] = useState('0');
  const [aviator, setAviator] = useState();
  const [ludo, setLudo] = useState();
  const [toastActive, setToastActive] = useState(false);
  const [myInviteCode, setInviteCode] = useState();
  const [login_count, setTotalLogin] = useState();
  const isMobile = useIsMobile();
  // const { theme, handleThemeChange } = useTheme();
  const [loading, setLoading] = useState(true);
  const [logoPath, setLogoPath] = useState('');
  const [showInput, setShowInput] = useState(false);


  const [showMenu, setShowMenu] = useState(false);
  const [showMenuSm, setShowMenuSm] = useState(false);
  const menuRef = useRef();
  const menuSmRef = useRef();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenuSm(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const showLogo = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + '/api/webapi/fetchLogoAction', {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = response.data.data.result[0];

      if (data && data.logo_image) {
        setLogoPath(data.logo_image); // example: '/payment/logo123.jpg'
      }

    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    showLogo();
  }, []);



  const handleClicktoast = () => {
    toast.success("Coming soon");
  };

  const [hovered, setHovered] = useState(null);

  const handleMouseEnter = (key) => setHovered(key);
  const handleMouseLeave = () => setHovered(null);

  const isHovered = (key) => hovered === key;

  const isSmallScreen = window.innerWidth <= 768;
  const topValue = location.pathname === '/'
    ? 98
    : isSmallScreen
      ? 0
      : !isAuthenticated
        ? 98
        : 79;
  const styles = {
    radheExchange: {
      display: isSmallScreen ? 'block' : 'none',
      fontFamily: 'Roboto Condensed, sans-serif',
      position: 'sticky',
      top: 0,
      zIndex: 99,
      width: '100%'
    },
    radheExchange2: {
      display: isSmallScreen ? 'none' : 'block',
      fontFamily: 'Roboto Condensed, sans-serif',
      // position: 'sticky',
      // top: 0,
      // zIndex: 99,
      width: '100%'
    },
    marqueeDiv: {
      backgroundColor: themeColors['--dark-theme-dark-blue-variant'],
    },
    headerContainer: {
      backgroundColor: 'rgb(0, 0, 0)',
      color: 'white',
      padding: isSmallScreen ? "5px 5px 10px" : "0px 5px"
    },
    aviator: {
      position: 'absolute',
      display: 'flex',
      fontSize: '8px',
      top: isSmallScreen ? '3px' : '-10px',
      left: isSmallScreen ? '16px' : "15px",
      height: "20px"
    },
    menuItemStyle: {
      padding: ".25rem 1rem",
      fontSize: "16px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      color: themeColors['--dark-theme-white-color']
    },
    navItemsLanding: {
      position: 'relative',
      padding: isSmallScreen ? '4px' : '16px 7px',
      top: isSmallScreen ? '0px' : '0px',
      height: isSmallScreen ? '' : "40px",
    },
    navLanding: {
      // position: 'sticky',
      // top: topValue,
      width: isSmallScreen ? '100%' : '100%',
      height: isSmallScreen ? '140px' : '40px',
    },
    demoAccountDiv: {
      position: 'relative',
    },
    demoAccountBtn: {
      backgroundColor: themeColors['--dark-theme-demoaccount'],
      color: themeColors['--dark-theme-color-navbar'],
      position: 'absolute',
      bottom: isSmallScreen ? 46 : 21,
      border: 'none',
      right: isSmallScreen ? 16 : 152,
      borderRadius: '4px',
      width: isSmallScreen ? '145px' : '150px',
      paddingTop: isSmallScreen ? '3px' : '7px',
      fontSize: isSmallScreen ? '10px' : '12px',
      fontWeight: 'bold',
      fontFamily: 'Roboto Condensed, sans-serif',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
    },
    accountInfo: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: isSmallScreen ? 'flex-end' : "flex-start",
    },
    login: {
      background: themeColors['--dark-theme-button-special'],
      width: isSmallScreen ? '78px' : "90px",
      borderRadius: isSmallScreen ? '8px' : '10px',
      fontSize: isSmallScreen ? '12px' : '14px',
      padding: isSmallScreen ? '3px 0px' : '8px 5px',
      border: "1px solid #16c0dd",
      color: themeColors['--dark-theme-data-bg'],
      fontWeight: 'bold',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    },
    balanceBox: {
      background: themeColors['--dark-theme-button-special'],
      width: isSmallScreen ? '78px' : "100px",
      borderRadius: isSmallScreen ? '5px' : '7px',
      fontSize: isSmallScreen ? '12px' : '14px',
      padding: isSmallScreen ? '0px 3px' : '1px 5px',
      border: "1px solid #16c0dd",
      color: themeColors['--dark-theme-color-navbar'],
      fontWeight: '500',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    expBox: {
      background: themeColors['--dark-theme-button-special'],
      marginTop: '2px',
      borderRadius: isSmallScreen ? '5px' : '7px',
      fontSize: isSmallScreen ? '12px' : '14px',
      width: isSmallScreen ? '78px' : "100px",
      padding: isSmallScreen ? '0px 3px' : '0px 5px',
      border: "1px solid #16c0dd",
      color: themeColors['--dark-theme-color-navbar'],
      fontWeight: '500',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    },
    spanBox: {
      fontSize: isSmallScreen ? '12px' : '14px',
    },
    textNowrapSm: {
      overflowX: 'auto',
      display: 'flex',
      padding: isSmallScreen ? '0px' : '5px 0px',
      width: isSmallScreen ? '100%' : '85%',
      gap: isSmallScreen ? '13px' : '',
    },
    textNowrap: {
      overflowX: 'auto',
      display: 'flex',
      padding: isSmallScreen ? '4px' : '0px',
      width: isSmallScreen ? '50%' : '65%',
      gap: isSmallScreen ? '13px' : '',
    },
    dates: {
      fontSize: isSmallScreen ? "11px" : '12px',
      color: themeColors['--dark-theme-color-navbar'],
    },
    offcanvas_menu: {
      color: themeColors['--dark-theme-color-navbar'],
    },
    reactIcon: {
      height: "19px",
      width: "19px",
      fontWeight: 'bold',
      marginRight: isSmallScreen ? '2px' : '',
    }
  }

  const [checked, setChecked] = useState(true);
  const [checked2, setChecked2] = useState(true);
  const onChange = e => {
    console.log('checked = ', e.target.checked);
    setChecked(e.target.checked);
  };
  const onChange2 = e => {
    console.log('checked2 = ', e.target.checked);
    setChecked2(e.target.checked);
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <a onClick={() => navigate("/sports_bets", { state: { activeTab: 3 } })} style={styles.menuItemStyle}>
          Account Statement
        </a>
      ),
      key: '0',
    },
    {
      label: (
        <a onClick={() => navigate("/sports_bets", { state: { activeTab: 0 } })} style={styles.menuItemStyle}>
          Current Bet
        </a>
      ),
      key: '1',
    },
     {
      label: (
        <a onClick={() => navigate("/sports_bets", { state: { activeTab: 1 } })} style={styles.menuItemStyle}>
          Current Bet
        </a>
      ),
      key: '2',
    },
    {
      label: (
        <>
          <a style={styles.menuItemStyle}>
            Balance
          </a>
          <Checkbox style={{ paddingLeft: "60px" }} checked={checked} onChange={onChange}>

          </Checkbox>
        </>
      ),
      key: '3',
    },
    {
      label: (
        <>
          <a style={styles.menuItemStyle}>
            Exposure
          </a>
          <Checkbox style={{ paddingLeft: "51px" }} checked={checked2} onChange={onChange2}>

          </Checkbox>
        </>
      ),
      key: '4',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <a style={styles.menuItemStyle} onClick={() => {
          setsidebaar(false);
          logout();
        }}>
          SignOut
        </a>
      ),
      key: '5',
    },
  ];


  function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
  }

  const handleHamburger = () => {
    setSidebar(prev => !prev);
    if (isMobile) setsidebaar(false);
  };

  const handleSettings = () => {
    setsidebaar(prev => !prev);
    if (isMobile) setSidebar(false);
  };

  useEffect(() => {
    if (sidebaar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [sidebaar]);
  useEffect(() => {
    if (isSidebar && isMobile) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isSidebar]);


  const handleClick = (linkName) => {
    setActiveLink((prev) => (prev === linkName ? null : linkName));
  };
  const handleOneClickBtn = (e) => {
    e.preventDefault();
    document.querySelector('.active_one_click')?.classList.remove('active_one_click');
    if (activeOneClickBtn.current) {

      activeOneClickBtn.current.classList.remove("active_one_click");
    }
    e.target.classList.add("active_one_click");
    activeOneClickBtn.current = e.target;

  }

  const [loginFormData, setLoginFormData] = useState({
    phoneNumber: "9999999999",
    password: "123456",
    iAcceptAll: true,
  });

  const submitlogin = (e) => {
    e.preventDefault();
    //  if (!loginFormData.phoneNumber || !loginFormData.password) {
    //    ToastMessage(0, "All fields are required!");
    //    return;
    //  }
    //  if (!/^\d{10}$/.test(loginFormData.phoneNumber)) {
    //   ToastMessage(0, "PhoneNumber should be 10 digits");
    //   return;
    // }
    //  if(!loginFormData.iAcceptAll){
    //    ToastMessage(0,"Please Accept The Terms And Conditions");
    //    return;
    //  }
    let { iAcceptAll, ...data } = loginFormData;
    login(data, function (res) {
      if (res.status) {
     
        ToastMessage(1, res.message);

        setactive(false);
        setregactive(false);
        navigate('/');

      } else {
        ToastMessage(0, res.message);
      }
    });
  };


  const allowedPaths = [
    "/home",
    "/cricketBet",
    "/sportall",
    "/cricketreal",
    "/footballreal",
    "/tennisreal",
    "/inplay",
    "/casinoGames",
  ];


  //  handle bonus
  // const handleClaimBonus = async () => {
  //   try {
  //     if (userBal.bonus === 0) {
  //       return;
  //     }
  //     const TotalUpdatedMoney = parseInt(userBal.userTotalBal) + (70 / 100) * userBal.bonus;
  //     const user_phone = userid.userPhone;

  //     const res = await axios.post(`${base_url}/api/webapi/admin/updateBonus`,
  //       { TotalUpdatedMoney, user_phone },
  //       {
  //         withCredentials: true,
  //         headers: {
  //           Accept: 'application/json'
  //         }
  //       }
  //     )

  //     if (res?.success) {
  //       setRefresh(!refresh);
  //       ToastMessage(1, res.message);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }


  // const handleSubmit = async () => {
  //   const token = localStorage.getItem('game_token');
  //   try {
  //     const response = await axios.post(base_url + '/api/webapi/casinoLobby', { token },
  //       {
  //         withCredentials: true,
  //         headers: {
  //           'content-type': 'application/json',
  //         }
  //       }
  //     )

  //     // console.log('lobby',response);
  //     if (response?.data.success) {
  //       window.location.href = response?.data.url;
  //     } else {
  //       toast.error(response?.data.message);
  //     }

  //   } catch (err) {
  //     console.log(err);
  //   }
  // }

  const handleGames = async () => {
    try {
      const token = localStorage.getItem('game_token');
      const response = await axios.get(base_url + '/api/webapi/particularGame', {
        params: {
          token,
          provider: 'SPB',
        },
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
        },
      });
      // console.log('games',response?.data);
      const games = response?.data?.items;

      const avia = games?.filter(game => game?.name.includes('Aviator'));
      // console.log('aviator',avia[0]);
      const id = avia[0]?.id;
      setAviator(id);

    } catch (err) {
      console.log(err);
    }
  }

  const handleGames1 = async () => {
    try {
      const token = localStorage.getItem('game_token');
      const response = await axios.get(base_url + '/api/webapi/particularGame', {
        params: {
          token,
          provider: 'JIL',
        },
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
        },
      });
      // console.log('games',response?.data);

      const games = response?.data?.items;

      const avia = games?.filter(game => game?.name.includes('Ludo'));
      // console.log('ludo',avia[0]);
      const id = avia[0]?.id;
      setLudo(id);
    } catch (err) {
      console.log(err);
    }
  }

  const openGameById = async (gameId) => {
    console.log('id',gameId);
    try {
      const token = localStorage.getItem('game_token');
      const response = await axios.post(base_url + '/api/gamelaunch/url',
        { token, gameId },
        {
          withCredentials: true,
          headers: {
            'content-type': 'application/json',
          }
        }
      )

      // console.log('url response',response);
      if (response?.data.success) {
        const url = response?.data.url;
        window.location.href = url;

      } else {
        toast.error('Please Login to Play.');
        setactive(true);
      }


    } catch (err) {
      console.log(err);
    }
  }

// useEffect(() => {
//   if (!isAuthenticated || !userInfo) return;

//   setuserid({
//     nameUser: userInfo.nameUser,
//     userPhone: userInfo.userPhone,
//     userName: userInfo.userName,
//   });
// }, [isAuthenticated, userInfo]);




  // const userAmount = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${base_url}/api/webapi/GetUserInfo`,
  //       {},
  //       { withCredentials: true, headers: { 'content-type': "application/json" } }
  //     );
  //     const data = response.data;
  //     setUserBal({ userTotalBal: data.data.money_user, bonus: data.bonus_money || 0 });
  //   } catch (error) {
  //     console.error("User data error:", error.message);
  //   }
  // };

  // useEffect(() => {
  //   userAmount();
  // }, []) 



  useEffect(() => {
    const LiabilityBalance = async () => {
      try {
        const response = await axios.get(`${base_url}/get/liability`, {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        });

        if (response?.data?.data?.totalLiability) {
          setLiability(response?.data?.data?.totalLiability);
        } else {
          setLiability('0');
        }
      } catch (error) {
        setLiability('0');
      }
    };

    // Call immediately on mount
    // LiabilityBalance();
    handleGames();
    handleGames1();

    // Set up interval
    const interval = setInterval(() => {
      // LiabilityBalance();
    }, 5000); 
    // 5 seconds

    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, []);

  // console.log('ludo',ludo);


  // Add CSS to handle responsive design
  const addResponsiveCSS = () => {
    const css = `
    @media (max-width: 768px) {
      .betting-navbar .navbar-nav {
        flex-direction: column !important;
      }
      
      .account-info {
        justify-content: center !important;
        margin-top: 10px !important;
      }
      
      .header-container .row {
        flex-direction: row !important;
      }
      
      .header-container .col-md-4 {
        text-align: center !important;
      }
    }
  `;

    const styleElement = document.createElement('style');
    styleElement.innerHTML = css;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  };

  React.useEffect(() => {
    // Add responsive styles when component mounts
    const cleanup = addResponsiveCSS();

    // Remove styles when component unmounts
    return cleanup;
  }, []);

  const isHomePage = location.pathname === '/';

  // const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  useEffect(() => {
    if (sidebaar) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [sidebaar]);

  // current date and time
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formattedDate = currentTime.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });

  const formattedTime = currentTime.toLocaleTimeString('en-GB');


  return (
    <>

      <style>{`
  .navItems-landingSm[_ngcontent-jrx-c95]:hover {
    color: skyblue;
    background-color: transparent !important;
  }
  .offcanvas-header .btn-close {
  filter: brightness(0) invert(1);
    height: 25px;
    width: 20px;
    opacity: var(--bs-btn-close-focus-opacity);
}
  .btn-close {
    --bs-btn-close-bg: url(https://png.pngtree.com/png-vector/20220628/ourmid/pngtree-icon-close-button-incorrect-forbidden-png-image_5286028.png) !important;
    background-size: 100% 100% !important;
  }
  .user_tabs p{
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 8px;
        padding-right: 0px;
        color: themeColors['--dark-theme-color-navbar'];
  }
  .user_tabs p:hover {
    background-color: themeColors['--dark-theme-time-remaining'];
    cursor: pointer;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .rules {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 8px;
        padding-right: 0px;
  }
  .btn-close{
    position: relative;
    top: 0px;
    z-index: 99;
  }

  
.search-container {
  display: flex;
  align-items: center;
  margin-top: 6px !important;
  justify-content: flex-end;
  background-color: var(--bg-primary);
  padding: 1px;
  border-radius: 4px;
  position: relative;
}
  
.search-container1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: var(--bg-primary);
  padding: 1px;
  border-radius: 4px;
  position: relative;
}

.search-input-wrapper {
  overflow: hidden;
  width: 0;
  transition: width 0.4s ease;
}

.search-input-wrapper.show {
  width: 150px;
}

.search-input-wrapper1 {
  overflow: hidden;
  width: 0;
  transition: width 0.4s ease;
}

.search-input-wrapper1.show {
  width:135px;
}

.search-input {
  padding: 7px 12px;
  background-color: var(--dark-theme-color-navbar) !important;
  border: none;
  border-radius: 0px;
  outline: none;
  font-size: 14px;
  color: var(--dark-theme-white-color) !important;
  width: 100%;
  transition: all 0.4s ease;
}
.search-input::{
  color: var(--dark-theme-white-color) !important;
}

.search-icon {
  background-color: var(--bg-primary);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 30px;
  margin-left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--dark-theme-color-navbar);
  font-size: 16px;
}

.search-icon:hover {
  background-color: var(--bg-primary);
}

.header_items{
    display: flex;
    flex-direction: column;
    font-size: 16px;
    justify-content: center;
}
         
  @media (max-width: 768px) {
    .navItems-landingSm[_ngcontent-jrx-c95]:hover {
      color: skyblue !important;
      background-color: transparent !important;
    }

    .navItems-landing[_ngcontent-jrx-c95] span[_ngcontent-jrx-c95]:hover {
      color: skyblue !important;
    }
    .header_items{
      font-size: 12px;
      align-items: end;
    }
    .search-input{
      padding: 3px 12px;
    }
  }
`}</style>
      {/* Small screen */}
      <div style={styles.radheExchange}>
        <div style={styles.headerContainer} className="header-container">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-6 col-6 mb-0 py-0 ps-0">
                <div _ngcontent-jrx-c79="" className="sidebar-header" style={{ display: "flex !important" }}>
                  <a
                    _ngcontent-jrx-c79=""
                    routerlink="/home"
                    className="d-flex align-items-center"
                    style={{ textDecoration: "none" }}
                    href="#"
                  >
                    {!isSidebar && location.pathname == "/home" && (
                      <Link
                        _ngcontent-mkq-c111=""
                        data-target="nav-mobile"
                        className="sidenav-trigger"
                        onClick={handleHamburger}
                      >
                        <LuMenu style={{ color: "white", fontSize: "26px", paddingRight: "2px" }} />
                      </Link>
                    )}
                    {location.pathname !== "/home" && (
                      <FaHome className="px-1" style={{ color: "white", fontSize: "31px" }} />
                    )}
                    <img
                      _ngcontent-jrx-c79=""
                      className="img-fluid top_dark"
                      style={{ width: "58px", height: "35px" }}
                      src= "https://sitethemedata.com/sitethemes/goid9.com/front/logo.png"
                      onClick={() => navigate("/home")}
                      alt="PrimeXexchange_logo"
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-6 p-0 mb-0 pe-1">
                <div className="col-lg-5 mb-0 header_items px-0">
                  <p className="mb-0 me-2" style={{ display: checked ? "block" : "none" }} >Balance: <span className="fw-bold">{Number(userBalnc?.userTotalBal ?? 0).toFixed(2)}</span>
</p>
                  <div style={{ position: "relative", display: "inline-block" }} ref={menuSmRef}>
                    <div
                      onClick={() => setShowMenuSm(!showMenuSm)}
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        cursor: "pointer",
                        backgroundColor: themeColors['--bg-primary'],
                        padding: "0px",
                        display: "flex",
                        borderRadius: "4px",
                        fontSize: isSmallScreen ? "12px" : "14px",
                      }}>
                      <span className="mb-0 me-1" style={{ display: checked2 ? "block" : "none" }}>Exp: <span className="fw-bold">{(liability)?"":""}{liability}</span></span>
                      <Dropdown menu={{ items }}>
                        <a onClick={(e) => e.preventDefault()}>
                          <Space style={{ color: "white" }}>
                       {userInfo?.userName}


                            <DownOutlined style={{ color: 'white' }} />
                          </Space>
                        </a>
                      </Dropdown>
                    </div>


                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="px-0 d-flex ms-auto">
                <div className="search-container1 my-0">
                  <div className={`search-input-wrapper1 ${showInput ? "show" : ""}`}>
                    <input
                      type="text"
                      className="search-input"
                      placeholder="Search here"
                    />
                  </div>
                  <button
                    className="search-icon px-0"
                    onClick={() => setShowInput(!showInput)}
                  >
                    <PiMagnifyingGlassPlusBold style={{ height: "28px", width: "28px", color: themeColors['--dark-theme-color'], fontWeight: "bold" }} />
                  </button>
                </div>
                <marquee scrollamount="3" style={{ backgroundColor: themeColors['--bg-primary-hover'] }}>
                  <p className="mb-0 pt-2" style={{ fontSize: "13px", color: themeColors['--dark-theme-color-navbar'] }}><i>💥 Luck’s on fire—go scratch higher!🎉Wickets fall, jackpots call – Asia Cup magic beats them all! 🌟🏏.</i></p>
                </marquee>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={styles.radheExchange2}>
        <div style={styles.headerContainer} className="header-container">
          <div className="container-fluid px-0">
            <div className="row align-items-center">
              <div className="col-md-6 col-6 mb-0 py-1">
                <div _ngcontent-jrx-c79="" className="sidebar-header" style={{ display: "flex !important" }}>

                  <a
                    _ngcontent-jrx-c79=""
                    routerlink="/home"
                    className="d-flex align-items-center"
                    style={{ textDecoration: "none" }}
                    href="/home"
                  >
                    <img
                      _ngcontent-jrx-c79=""
                      className="img-fluid top_dark ms-1"
                      style={{ width: "102px", height: "65px" }}
                      src="https://sitethemedata.com/sitethemes/goid9.com/front/logo.png"
                      alt="PrimeXexchange_logo"
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-6 px-0 mb-0 pt-0 pb-0">
                <div className="d-flex mt-0 pt-2">
                  <div className="px-0 ms-auto mb-0">
                    <div className="search-container my-0">
                      <div className={`search-input-wrapper ${showInput ? "show" : ""}`}>
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search here"
                        />
                      </div>
                      <button
                        className="search-icon"
                        onClick={() => setShowInput(!showInput)}
                      >
                        <PiMagnifyingGlassPlusBold style={{ height: "35px", width: "35px", color: themeColors['--dark-theme-color'], fontWeight: "bold" }} />
                      </button>
                    </div>

                  </div>
                  <div className="mb-0 px-0 ms-1 header_items">
                    <p className="fw-bold mb-0"> Rules</p>
                  </div>
                  <div style={styles.accountInfo} className="px-0 mb-0 mx-4 header_items">
                    <p className="mb-0" style={{ fontSize: "15px", lineHeight: 'normal' }}>Balance: <span className="fw-bold">
                      {Number(userBalnc?.userTotalBal ?? 0).toFixed(2)}
                    </span></p>
                    <p className="mb-0" style={{ fontSize: "15px", lineHeight: 'normal' }}>Exp: <span className="fw-bold">{(liability>0)?"-":""}{liability}</span></p>
                  </div>
                  <div className=" ps-0 mb-0 header_items">
                    <div className="me-auto" style={{ position: "relative", display: "inline-block" }} ref={menuRef}>
                      <div
                        onClick={() => setShowMenu(!showMenu)}
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          cursor: "pointer",
                          backgroundColor: themeColors['--bg-primary'],
                          padding: "0px 15px 0px 0px",
                          borderRadius: "4px",
                          fontSize: "14px",
                        }}
                      >
                       {userInfo?.userName}
 <span><IoIosArrowDown style={styles.reactIcon} />
                        </span>
                      </div>

                      {showMenu && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            right: 0,
                            backgroundColor: "white",
                            border: "1px solid #ccc",
                            borderRadius: "2px",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                            minWidth: "180px",
                            zIndex: 1000,
                            marginTop: "4px",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          }}
                        >
                          <div onClick={() => navigate("/sports_bets", { state: { activeTab: 3 } })} style={styles.menuItemStyle}>Account Statement</div>
                          <div onClick={() => navigate("/sports_bets", { state: { activeTab: 0 } })} style={styles.menuItemStyle}>Sport Bets</div>
                          <div onClick={() => navigate("/sports_bets", { state: { activeTab: 1 } })} style={styles.menuItemStyle}>Casino Bet</div>

                          {/* <div style={styles.menuItemStyle}>Set Button Values</div> */}
                          <hr style={{ margin: "5px 0", color: 'grey' }} />
                          <div style={styles.menuItemStyle} onClick={() => {
                            setsidebaar(false);
                            logout();
                          }}>SignOut</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <marquee scrollamount="3">
                    <p className="mb-0" style={{ fontSize: "13px", fontWeight: "bold", color: themeColors['--dark-theme-color-navbar'] }}><i>💥 Luck’s on fire—go scratch higher!🎉Wickets fall, jackpots call – Asia Cup magic beats them all! 🌟🏏</i></p>
                  </marquee>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div _ngcontent-jrx-c95="" className="nav-landing d-lg-flex d-md-none d-none" style={{ ...styles.navLanding, zIndex: 99, display: !isAuthenticated && isSmallScreen ? 'none' : 'flex', }}>

          <div
            style={styles.textNowrap}

            className="text-nowrap"
          >
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted mb-2"
            >
              <span _ngcontent-jrx-c95="" className="my-auto"
                onMouseEnter={() => handleMouseEnter('home')}
                onMouseLeave={handleMouseLeave}
                onClick={() => navigate('/home')}
                style={{
                  ...styles.navItemsLanding,
                  borderBottom: isHovered('home')
                    && `2px solid ${themeColors['--dark-theme-color']}`
                }}>HOME</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding,
                borderBottom: isHovered('cricketreal')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('cricketreal')}
              onMouseLeave={handleMouseLeave}
              onClick={() => navigate("/cricketreal")}
            >
              <span _ngcontent-jrx-c95="" className="my-auto">CRICKET</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding,
                borderBottom: isHovered('FOOTBALL')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('FOOTBALL')}
              onMouseLeave={handleMouseLeave}
              onClick={() => navigate("/footballreal")}
            >
              <span _ngcontent-jrx-c95="" className="my-auto">FOOTBALL</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted"
              style={{
                ...styles.navItemsLanding,
                borderBottom: isHovered('tennisreal')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('tennisreal')}
              onMouseLeave={handleMouseLeave}
              onClick={() => navigate('/tennisreal')}
            >
              <span _ngcontent-jrx-c95="" className="my-auto">TENNIS</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding,
                borderBottom: isHovered('Horse')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('Horse')}
              onMouseLeave={handleMouseLeave}
             onClick={() =>
                    navigate("/casinoGames", { state: { list: 17 } })
                  }
            >
              <span _ngcontent-jrx-c95="" className="my-auto" > AE SEXY</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, borderBottom: isHovered('Greyhound')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('Greyhound')}
              onMouseLeave={handleMouseLeave}
              onClick={() =>
                    navigate("/casinoGames", { state: { list: 10 } })
                  }
            >
              <span _ngcontent-jrx-c95="" className="my-auto">BACCARAT</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, borderBottom: isHovered('IndianPoker')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('IndianPoker')}
              onMouseLeave={handleMouseLeave}
            onClick={() => navigate('/casinoGames', { state: { list: 9 } })}
            >
              <span _ngcontent-jrx-c95="" className="my-auto" >ROULETTE</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, borderBottom: isHovered('Poker')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('Poker')}
              onMouseLeave={handleMouseLeave}
  onClick={() =>
                    navigate("/casinoGames", { state: { list: 4 } })
                  }
            >
              <span _ngcontent-jrx-c95="" className="my-auto">TEENPATTI</span>
            </div>

            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, borderBottom: isHovered('aeSexy')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('aeSexy')}
              onMouseLeave={handleMouseLeave}
             onClick={() => navigate('/casinoGames', { state: { list: 14 } })}
            >
              <span _ngcontent-jrx-c95="" className="my-auto">POKER</span>
            </div>

            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, borderBottom: isHovered('Evolution')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('Evolution')}
              onMouseLeave={handleMouseLeave}
            onClick={() =>
                    navigate("/casinoGames", { state: { list: 16 } })
                  }
            >
              <span _ngcontent-jrx-c95="" className="my-auto">SLOTS</span>
            </div>
            <div
              _ngcontent-jrx-c95=""
              className="navItems-landing ng-star-inserted" style={{
                ...styles.navItemsLanding, padding: "6px 0px", borderBottom: isHovered('Aviator')
                  && `2px solid ${themeColors['--dark-theme-color']}`
              }}
              onMouseEnter={() => handleMouseEnter('Aviator')}
              onMouseLeave={handleMouseLeave}
                 onClick={() =>
                    navigate("/casinoGames", { state: { list: 11 } })
                  }
            >
              {/* <span _ngcontent-jrx-c95="" className="my-auto">AVIATOR</span> */}
              <svg style={{ transform: "rotate(10deg)" }} id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 457.6 277.4" className="blink_me"><defs><style>{`.cls-1 { fill: #e40539; }`}</style></defs><g id="Layer_1-2" data-name="Layer 1"><g><path className="cls-1" d="M61.85,273.4c-1.8-3.5-2.3-3.9-4-3-3.2,1.7-5.5,1.1-9-2.5l-3.3-3.4,4.4-1.9c2.4-1.1,8-2.2,12.4-2.6,27.1-2.5,84.1-19.2,161-47.1,32.1-11.7,80.4-30.1,81.3-31,1.2-1.2-1-1.5-11.9-1.7-10.6-.2-11.7,0-16.5,2.4-13.1,6.8-74.6,31.2-92.8,36.7l-6.9,2.1-6.4-5-6.5-4.9-3.6,1.5c-21.3,9-88,36.4-89.2,36.6-1,.2-1.6-.6-1.8-2.3-.3-2.4.5-3,7.8-6.9,4.5-2.3,7.9-4.5,7.5-4.8-.3-.4-4.3-.9-8.9-1.3-9.7-.8-17.3-4-28.2-11.9-4.8-3.5-7.8-5-10-5-4.3,0-6.4.9-6.4,2.7,0,.8,6.8,8.7,15.1,17.6,13,13.7,14.9,16.2,13.3,16.8-3.7,1.5-4.8.8-16.3-10.3-6.4-6.2-14.6-14.2-18.3-17.7l-6.7-6.5-8.8,4.2-8.8,4.2-.3-3.4c-.2-2,.2-4.4.8-5.5s6.5-4.8,13.1-8.2c11.8-6,14.2-8,12.2-10-.7-.7-4.1.5-10.2,3.5l-9.1,4.6v-2.5c0-2,1.4-3.3,7.7-7,10.3-6,17.3-8.1,22.3-6.6,2.1.6,10.7,6.3,19.1,12.6,19,14.3,29.4,19.9,35.9,19.2,5.3-.5,34-13.7,61.9-28.5,18.3-9.7,21.6-12.1,19.5-14.2-.7-.7-7.1,1.8-21.4,8.5-14.7,7-20.5,9.3-21.1,8.4-1.2-2-.1-3.3,5.6-6.3,3-1.6,5.5-3.4,5.5-4,0-.7-1.3-2.5-2.8-4l-2.9-2.7-19.8,9.6c-10.9,5.2-20,9.3-20.2,9.1-.8-.7,2.5-12.8,3.8-14.1.8-.8,9.5-5.6,19.4-10.8,17.7-9.4,18-9.6,17.8-12.7,0-1.7-.4-3.4-.7-3.7s-3.9.9-8,2.7l-7.4,3.3-8.9-9.3c-4.8-5.1-8.9-9.6-9.1-10-.5-1.4,8.8-7.9,14.6-10.1,10.4-4,10.9-3.9,118.5,11.3,35.6,5,65.5,9.7,66.5,10.4,1.6,1.1,1.6,1.4-.1,4.8l-1.7,3.7,2.8,1c1.5.5,5.8,2.1,9.5,3.6l6.9,2.5,10.1-4.3c12.4-5.2,32.9-15.6,45.6-23.2l9.4-5.5,3.2,2.4c3.2,2.4,6.9,3.1,7.9,1.6.3-.5-2.5-6.9-6.3-14.3-3.7-7.4-8.7-18.4-11-24.4-2.4-6.1-4.8-11.6-5.4-12.4-.9-1-3.3-1.2-10.7-.8-10.8.5-18.1,2.6-42,12-15.4,6-67.7,31.5-70.6,34.4-1.3,1.4-3.4,1.4-19.2-.1-9.7-.9-18-1.6-18.4-1.6-1.4,0-.8-5.5,1.1-9.7,1.6-3.4,3.9-5.4,14-12.1,14.3-9.5,28.2-16.5,37.4-18.9l6.5-1.7,9.9,3.9c14.3,5.6,16.3,5.6,39.8-1,38.2-10.6,43.5-11.8,52.2-11.9,8-.1,8.3,0,11.6,3.3,2.6,2.5,5.7,8.3,12,23,4.7,10.8,9,21.3,9.7,23.5,1.7,5.4.8,11.9-2.4,16-6.7,8.8-38,25.2-82.1,42.8-22.8,9.1-61.8,21.9-162.5,53.3-31.1,9.7-64.7,20.3-74.6,23.6-10,3.2-18.9,5.9-19.8,5.9-.8,0-2.5-1.8-3.6-4ZM291.35,168.4c3.8-2.3,7.1-6.9,5.8-8-.6-.5-144.9-20.8-158.8-22.3-1.2-.1-2,.4-2,1.3,0,1.2,15.5,4.6,72,16.1,39.6,8.1,73.7,14.7,75.9,14.8,2.3.1,5.2-.7,7.1-1.9h0ZM247.65,122c4.2-2.3,11.2-5.8,15.4-7.7,4.3-1.9,7.8-3.7,7.8-4.1s-2.8-1.3-6.2-2c-7.7-1.7-13.7-.9-22.4,3.3-6.7,3.1-18.9,11.7-18.1,12.6.6.5,9.3,1.9,13.5,2.2,1.3,0,5.8-1.9,10-4.3h0ZM282.15,115.8c7.5-3.8,10.7-6,10.5-7.1-.4-2.1-18.3-9.2-23.4-9.3-2.2,0-4.9.6-6,1.4q-2.1,1.6,10.4,6.5c2.6,1,4.8,2.3,5,2.9s-1.9,2.2-4.7,3.6c-5.5,2.8-6.6,4-5.7,6.1.8,2.3,2.3,1.9,13.9-4.1h0Z"></path><path className="cls-1" d="M440.55,196.2c-6.8-10.1-13.5-20.3-14.9-22.8-1.5-2.5-5.5-14.1-9.1-25.7l-6.5-21.3,5.1-5c2.7-2.8,5.1-4.9,5.2-4.8.1.2,5.2,9.4,11.4,20.6,11.9,21.3,15.8,31,23.1,58,3.3,11.9,3.3,12.3,1.7,15.7-.9,1.9-2.1,3.5-2.6,3.5s-6.5-8.2-13.4-18.2h0ZM454.65,206.5c.2-1.9-.5-4.6-1.7-6.7-1.8-3.1-22-30.4-24.3-32.9-1.2-1.3-3,1.5-2.2,3.5,1.2,3.4,26,39.9,26.9,39.6.6-.1,1.1-1.7,1.3-3.5h0Z"></path><path className="cls-1" d="M295.35,148.3c-13.2-2.6-24.6-4.9-25.4-5.1-.8-.2,11.3-5.4,27-11.6l28.3-11.4,5.3,5.9c2.9,3.2,5.2,6.3,5.3,6.9,0,.6-2.3,5.5-5.1,10.8-4.8,9.1-5.2,9.6-8.2,9.5-1.8-.1-14-2.3-27.2-5h0Z"></path><path className="cls-1" d="M334.85,152.1c0-.2,1.6-3.6,3.6-7.5,1.9-4,4.1-9,4.9-11.1l1.3-3.8-5.3-6.9c-5.3-6.8-5.4-6.9-3.2-8.1,2-1.1,2.6-.8,6.2,3.2,2.2,2.5,4.3,4.5,4.6,4.5s1.7-3.9,3-8.7l2.4-8.8.3,4.9c.2,2.6-.2,8-.8,11.8l-1,7,5.1,6.4,5.1,6.4-2.7,1c-2.2.9-2.9.6-5-1.8-1.3-1.5-2.5-3-2.5-3.4-.1-2.3-1.9-.1-3.9,4.6-1.2,3-2.8,5.9-3.5,6.5-1.4,1.1-8.6,4.3-8.6,3.8h0Z"></path><path className="cls-1" d="M404.75,114.7c-7.2-16.1-7.3-16.4-5.8-17.5,1.5-1,21.2-.4,24.2.7.9.4,1.7,1.4,1.7,2.2,0,4.2-12.6,21.3-15.6,21.3-.9,0-2.8-2.9-4.5-6.7h0ZM414.15,104.7c4.8-2,8.7-4,8.7-4.4,0-1.2-4.4-1.9-13.2-1.9-8.2,0-8.8.1-8.8,2,0,2.4,2.7,8,3.8,8,.4,0,4.6-1.6,9.5-3.7Z"></path><path className="cls-1" d="M385.05,75.9c-10.7-19.1-14-27.3-20.7-51.6-4-14.3-4.3-18.7-1.6-22l1.9-2.3,14.8,22.3,14.8,22.3,7.6,24.2c4.2,13.2,7.4,24.2,7.1,24.3-.3.1-3.5.3-7.1.6l-6.5.4-10.3-18.2h0ZM391.85,46.5c0-1.5-23.2-37.5-26.1-40.6-1.3-1.3-2.9,1.2-2.9,4.7,0,2.5,8.8,15.4,22.3,32.7,4.6,6,6.7,7,6.7,3.2Z"></path></g></g></svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


